module.exports = __webpack_public_path__ + "assets/BtnTwit.9fcc9773.svg";